

























import Vue from 'vue';
import Component from 'vue-class-component';
import { PropSync } from 'vue-property-decorator';
import CardDisplayComponent from './CardDisplay.vue';
import { Card } from '@/store/cards/CardInterface';
import { Action } from 'vuex-class';

const namespace = 'cardList';

@Component({ components: { CardDisplayComponent } })
export default class CardComponent extends Vue {
    // send the action for the store to remove this element
    @Action('deleteCard', { namespace }) deleteCard: any;

    // receives the card prop and holds it for the template
    @PropSync('card') private item!: Card;
    private editable = false;
}
